import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_menu_terms_conditions",
  "use": "icon_menu_terms_conditions-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_menu_terms_conditions\"><path d=\"M5.615 0l3.077 3.077v5.961a.925.925 0 0 1-.288.674.922.922 0 0 1-.674.288H1.96a.922.922 0 0 1-.673-.288A.922.922 0 0 1 1 9.038V.962c0-.257.096-.481.288-.674A.922.922 0 0 1 1.962 0h3.653zm-.384 3.462h2.692L5.231.769v2.693z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol